import { STORY_SECTION } from './constants';
import MatthewImage from '../../../../../assets/images/Matthew.webp';
import {
  StorySectionWrapper,
  StoryPaper,
  StoryContent,
  StoryImageContainer,
  StoryImage,
  StoryTitle,
  StorySubtitle,
  StoryQuote,
  StoryQuoteSmall,
  StoryQuoteSmallItalic,
} from './styles';
import { Divider } from '@mui/material';

const StorySection = () => {
  return (
    <StorySectionWrapper>
      <StoryPaper elevation={0}>
        <StoryImageContainer>
          <StoryImage src={MatthewImage} alt="Matthew Brownstein" />
        </StoryImageContainer>

        <StoryContent>
          <StoryTitle>{STORY_SECTION.TITLE}</StoryTitle>

          <StorySubtitle>{STORY_SECTION.SUBTITLE}</StorySubtitle>

          <Divider sx={{ margin: '14px 0 8px' }} />
          <StoryQuote>{STORY_SECTION.QUOTE_PRIMARY}</StoryQuote>
          <Divider sx={{ margin: '10px 0' }} />

          <StoryQuoteSmall>{STORY_SECTION.QUOTE_SECONDARY}</StoryQuoteSmall>

          <StoryQuoteSmallItalic>{STORY_SECTION.QUOTE_TERTIARY}</StoryQuoteSmallItalic>
        </StoryContent>
      </StoryPaper>
    </StorySectionWrapper>
  );
};

export default StorySection;
